import SettingsNotificationsModule from './settings-notifications.module'

export default SettingsNotificationsModule
